import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { estadoPorSigla } from '@/shared/models/estados';

/**
 * Exibe uma UF do jeito que o seletor de estado a exibe: bandeira + `SIGLA - Nome`.
 *
 * <p>É a metade somente-leitura do `app-estado-select`. Existe porque uma UF apareceu em telas que
 * não selecionam nada — a coluna do catálogo de perfis e o cabeçalho de grupo do diálogo de aplicar
 * perfil — e ali uma sigla solta não diz muito: "DF" e "Distrito Federal" são a mesma coisa para
 * quem já conhece o sistema, e nada para quem não conhece. Lê a mesma lista que o seletor
 * (`ESTADOS`), então as duas nunca divergem no nome ou na bandeira.</p>
 *
 * <p>Sigla desconhecida cai para o texto cru em vez de sumir: a UF vem do banco, e esconder um
 * valor que existe é pior do que mostrá-lo sem enfeite.</p>
 */
@Component({
    selector: 'app-estado-rotulo',
    standalone: true,
    templateUrl: './estado-rotulo.html',
    styleUrls: ['./estado-rotulo.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EstadoRotulo {
    readonly uf = input<string | null>(null);

    protected readonly estado = computed(() => estadoPorSigla(this.uf()));
}
